import React from "react";
import { useAuth } from "../../hooks/useAuth";
import { LogOut, AlertTriangle, Mail } from "lucide-react"; // Importa ícones
import { Link } from "react-router-dom"; // Para link de contato/planos

const BlockedAccountPage = () => {
  const { companyInfo, logout } = useAuth();

  // Determina a mensagem com base no status da assinatura
  let title = "Conta Inativa";
  let message =
    "Sua conta está atualmente inativa. Por favor, entre em contato com o suporte para mais informações.";
  let contactLabel = "Contatar Suporte";
  let contactLink = "/suporte"; // Exemplo, ajuste conforme necessário

  if (companyInfo?.subscriptionStatus === "expired_trial") {
    title = "Período de Avaliação Expirado";
    message =
      "Seu período de avaliação gratuito terminou. Para continuar utilizando os recursos do FleetControl, por favor, entre em contato com nosso time comercial para escolher um plano que se adeque às suas necessidades.";
    contactLabel = "Ver Planos / Contato Comercial";
    contactLink = "/planos"; // Exemplo, ajuste para a página de planos ou contato
  } else if (companyInfo?.subscriptionStatus === "inactive_payment") {
    // Placeholder para futura implementação de inadimplência
    title = "Pagamento Pendente";
    message =
      "Identificamos uma pendência no pagamento da sua assinatura. Sua conta foi temporariamente suspensa. Regularize a situação para reativar seu acesso.";
    contactLabel = "Verificar Pagamento";
    contactLink = "/assinatura"; // Exemplo, ajuste para a página de gestão da assinatura
  }
  // Outros status inativos podem ser adicionados aqui com 'else if'

  // --- FUNÇÃO handleLogout MODIFICADA ---
  const handleLogout = async () => {
    console.log("Tentando fazer logout..."); // Log 1: Início
    try {
      await logout(); // Chama a função de logout do useAuth
      console.log("Logout realizado com sucesso via useAuth."); // Log 2: Sucesso
      // Força o redirecionamento para garantir, caso o listener de auth não pegue a tempo
      window.location.href = "/login";
    } catch (error) {
      console.error("Erro durante o logout:", error); // Log 3: Erro
      // Tenta forçar o redirecionamento mesmo em caso de erro no logout
      // (Ex: se a função logout falhar por algum motivo inesperado)
      window.location.href = "/login";
    }
  };
  // --- FIM DA MODIFICAÇÃO ---

  return (
    <div className="flex items-center justify-center min-h-screen bg-light-bg dark:bg-dark-bg p-4">
      <div className="w-full max-w-md p-8 space-y-6 bg-light-card dark:bg-dark-card rounded-lg shadow-xl text-center border border-light-border dark:border-dark-border">
        <AlertTriangle className="mx-auto h-12 w-12 text-brand-red" />{" "}
        {/* Ícone de Alerta */}
        <h1 className="text-2xl font-bold text-light-text-primary dark:text-dark-text-primary">
          {title}
        </h1>
        <p className="text-sm text-light-text-secondary dark:text-dark-text-secondary">
          {message}
        </p>
        {/* Botão/Link de Contato (Ajuste o 'to' ou use um 'onClick') */}
        <Link
          to={contactLink}
          className="inline-flex items-center justify-center w-full px-4 py-2 text-sm font-medium text-white bg-brand-blue rounded-md shadow-sm hover:bg-brand-blue/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-blue"
        >
          <Mail className="w-4 h-4 mr-2" /> {/* Ícone de Email/Contato */}
          {contactLabel}
        </Link>
        {/* Botão de Logout */}
        <button
          onClick={handleLogout}
          className="inline-flex items-center justify-center w-full px-4 py-2 mt-4 text-sm font-medium text-light-text-secondary dark:text-dark-text-secondary bg-gray-100 dark:bg-gray-700 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
        >
          <LogOut className="w-4 h-4 mr-2" />
          Sair (Logout)
        </button>
      </div>
    </div>
  );
};

export default BlockedAccountPage;
